import "./HomePage.module.css";
import Header from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import AboutAaEaglePlumbing from "./sections/AboutAaEaglePlumbing";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import GetAFreeEstimate from "./sections/GetAFreeEstimate";
import Footer from "@/reusable_sections/Footer";
export default function HomePagePage() {
  return <div>
      <Header />
      <OurServices />
      <AboutAaEaglePlumbing />
      <CustomerTestimonials />
      <GetAFreeEstimate />
      <Footer />
    </div>;
}